export default {
  PUSH_CONVERSATION_DATA(state, value) {
    state.conversationData.push(value);
  },
  SET_ALEX_NAME(state, value) {
    state.alexName = value;
  },
};
